import React from 'react'
import ParseFloat from '../../utils/ParseFloat';
import Konsole from '../../utils/konsole/Konsole';
import { CheckMealItemIsCustomize } from '../../utils/Meal';
import { ItemSizeVariationName } from '../../utils/ItemSizeName';
import { ReturnPrice, ReturnPriceAndFree } from '../../utils/orderUtils/OrderUtils';
const MealOption = (props: any) => {
    //Konsole.log('propsprops', props);
    // meal_item_data
    let item_data = props?.item_data;
    let item_variation = props?.item_variation;

    // let itemName = item_data?.length > 0 ? `${item_data?.[0]?.name} (${item_variation?.variation_name})` : '';
    // //Konsole.log('itemName', itemName, item_data, props);
    let itemName = (item_data?.length > 0) ? `${item_data?.[0]?.name} ${ItemSizeVariationName(props)}` : ''

    //Konsole.log('MealOptionProps', props, props?.isChecked, props, props?.map_item_meal_id);

    const selectedItem = (props?.mItem?.selectedMealItem && props?.mItem?.selectedMealItem[0]?.map_item_meal_id == props?.map_item_meal_id) ? props?.mItem?.selectedMealItem : false;
    // console.log('selectedItem', selectedItem)


    const returnIsCustomizeEdit = () => {
        if (CheckMealItemIsCustomize(props)) {
            if (selectedItem) {
                return <i onClick={props.onchange} className="fa fa-pencil text-gray-700 cursor-pointer" aria-hidden="true"></i>
            } else {
                return <i onClick={props.onchange} className="fa fa-chevron-right text-gray-700 cursor-pointer" aria-hidden="true"></i>
            }
        }
    }

    // console.log("map_item_meal_id", props)

    return (
        <div className="chooseVariation w-full new-chooseVariation">
            <div className={CheckMealItemIsCustomize(props) && !selectedItem ? " " : (selectedItem[0]?.selectedoptions?.length > 0) ? " " : CheckMealItemIsCustomize(props) ? "flex justify-between items-center" : ""}>

                <label htmlFor={props.map_item_meal_id} >
                    <div
                        onClick={(e) => {
                            // if (CheckMealItemIsCustomize(props)) if (!selectedItem) 
                                props.onchange()
                        }}
                        className="variation_option textMd cursor-pointer ">
                        {CheckMealItemIsCustomize(props) && <p className="font-bold flex justify-between">{itemName} {CheckMealItemIsCustomize(props) && returnIsCustomizeEdit()}</p>}
                        {!CheckMealItemIsCustomize(props) &&
                            <div className='flex justify-between items-start w-full'>
                                 <div className="flex flex-col flex-grow">
                                <p className="font-bold">{itemName}</p>
                                {props.offered_price && <p className="font-normal text-[#4B4B4B]"> {ParseFloat(props.offered_price)}</p>}
                                </div>
                                <div className="flex items-center">
                                <input
                                    checked={props?.isChecked ? true : false}
                                    type="radio"
                                    id={props?.map_item_meal_id}
                                    // name={props?.sub_cate_id}
                                    name={props?.meal_id}
                                    onChange={props.onchange}
                                    className="w-5 h-5 accent-black shrink-0"
                                />
                                </div>
                            </div>}

                        
                    </div>

                </label>

                {(selectedItem?.length > 0 && selectedItem[0]?.map_item_meal_id == props?.map_item_meal_id) && <>
                    {/* @@ selected options item */}
                    {(selectedItem[0]?.selectedoptions?.length > 0) ? <>
                        {/* <ul> */}
                        {selectedItem[0]?.selectedoptions?.map((optionItem: any, optionIdex: number) => {
                            return <li className='capitalize' key={optionIdex}> {optionItem?.title} {ReturnPriceAndFree(ReturnPrice(optionItem))}</li>
                        })}
                        {/* </ul> */}
                    </> : null}
                    {/* @@ selected category */}
                    {(selectedItem[0]?.selectedCategory?.length > 0) ? <>
                        {selectedItem[0]?.selectedCategory?.map((optionItem: any, optionIdex: number) => {
                            return <li className='capitalize' key={optionIdex}> {optionItem?.mapNewItem?.name}  {ReturnPriceAndFree(ReturnPrice(optionItem?.mapNewItem))}</li>
                        })}
                    </> : null}
                    {/* @@ selected add oons */}
                    {(selectedItem[0]?.selected_addOn?.length > 0) ? <>
                        {selectedItem[0]?.selected_addOn?.map((addOnItem: any, optionIdex: number) => {
                            return <li className='capitalize' key={optionIdex}> {addOnItem?.addon_item?.name}  {ReturnPriceAndFree(addOnItem?.web_offered_price)}</li>
                        })}
                    </> : null}
                </>}
                {/* @@ Check item is customze or not */}
                {/* {CheckMealItemIsCustomize(props) ? null :
                <input
                    checked={props?.isChecked ? true : false}
                    type="radio"
                    id={props?.map_item_meal_id}
                    // name={props?.sub_cate_id}
                    name={props?.meal_id}
                    onChange={props.onchange}
                     className="w-5 h-5 accent-black shrink-0"
                   
                />
            } */}
            </div>

        </div>
    )
}

export default MealOption